import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { BaseParameterService } from './base-parameter.service';
import { LanguageService } from './language.service';

import CONFIGURATION from '../../configurations/configuration';
import { ENVIRONMENT } from '../../environments/environment';

import * as mixpanel from 'mixpanel-browser';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class EventService {
  CONFIGURATION: any;
  countryCode = CONFIGURATION.country_code;
  constructor(
    private authService: AuthService,
    private baseParameterService: BaseParameterService,
    private languageService: LanguageService
  ) {
    this.init();
  }

  init(): void {
    if (ENVIRONMENT.enableSendingMixPanelEvents) {
      mixpanel.init(ENVIRONMENT.mixpanel.token);
    }
  }

  sendInvSignupEvent(step, signUpSource = {}) {
    this.sendEvent(step, signUpSource);
  }

  sendBrwSignupEvent(step) {
    this.sendEvent(step, this.baseParameterService.getBrwSignUpEvents());
  }

  sendEvent(event, properties = {}) {
    properties = Object.assign(properties, { 'CountryPlatformCode': CONFIGURATION.country_code });
    if (ENVIRONMENT.enableSendingMixPanelEvents) {
      this.identify();
      this.setPeople();
      mixpanel.track(event, properties);
    }
  }

  sendCleverTapEvent(eventName) {
    const cleverTapEnabled = ENVIRONMENT.cleverTap[this.countryCode.toLowerCase()];
    if (cleverTapEnabled) {
      window['clevertap'].event.push(eventName);
    }
  }

  private getUserName() {
    return this.authService.getUserName();
  }

  private getFullName() {
    return this.authService.getFullName();
  }

  private setPeople() {
    const properties = {
      $name: this.getFullName(),
      $email: this.getUserName(),
      'language': this.languageService.getDefaultLanguage()
    };
    if (properties) {
      mixpanel.people.set(properties);
    }
  }

  private identify() {
    const alias = this.getUserName();
    if (alias) {
      mixpanel.identify(alias);
    }
  }
}
